import { formatTime, parseTime } from '@/utils/time';
export default {
  formatTime,
  parseTime,
};
